import React from 'react';

interface StatSectionProps {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  iconColor?: string;
  children: React.ReactNode;
  className?: string;
}

export const StatSection: React.FC<StatSectionProps> = ({
  title,
  icon: Icon,
  iconColor = 'text-purple-600',
  children,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${className}`}>
      <h3 className="text-xs font-medium text-gray-900 mb-6 flex items-center">
        <Icon className={`w-5 h-5 mr-2 ${iconColor}`} />
        {title}
      </h3>
      {children}
    </div>
  );
};

export default StatSection;
